import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsPreview } from './components/TestimonialsPreview';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomosSection } from './components/TomosSection';
import { TomoIncludes } from './components/TomoIncludes';
import { BonusesSection } from './components/BonusesSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
import { SafePilatesComparison } from './components/SafePilatesComparison';
import { SafePilatesModules } from './components/SafePilatesModules';
import { TestimonialsFull } from './components/TestimonialsFull';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PricingProvider } from './contexts/PricingContext';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1904779843432668');
    f.fbq('track', 'PageView');
  }, []);
  return <PricingProvider data-id="element-0">
      <div className="min-h-screen bg-offwhite font-inter selection:bg-sage-200 selection:text-sage-900" data-id="element-1">
        <Hero data-id="element-2" />
        <StatsBar data-id="element-3" />
        <TestimonialsPreview data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductOverview data-id="element-6" />
        <TomosSection data-id="element-7" />
        <TomoIncludes data-id="element-8" />
        <BonusesSection data-id="element-9" />

        {/* Mid-page urgency and pricing */}
        <section className="py-4 md:py-8 bg-offwhite" data-id="element-10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 md:mb-12" data-id="element-11">
            <CountdownTimer data-id="element-12" />
          </div>
        </section>

        <PricingCards data-id="element-13" />
        <SafePilatesComparison data-id="element-14" />
        <SafePilatesModules data-id="element-15" />
        <TestimonialsFull data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <ComparisonTable data-id="element-19" />
        <FinalCTA data-id="element-20" />
        <Footer data-id="element-21" />
      </div>
    </PricingProvider>;
}